module.exports = __webpack_public_path__ + "static/media/athleadhq-logo-white.8007f98e.png";